import { render, staticRenderFns } from "./Audio.vue?vue&type=template&id=453249bc&lang=pug&"
import script from "./Audio.vue?vue&type=script&lang=js&"
export * from "./Audio.vue?vue&type=script&lang=js&"
import style0 from "./Audio.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('453249bc')) {
      api.createRecord('453249bc', component.options)
    } else {
      api.reload('453249bc', component.options)
    }
    module.hot.accept("./Audio.vue?vue&type=template&id=453249bc&lang=pug&", function () {
      api.rerender('453249bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/admin/Audio.vue"
export default component.exports